import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';
import { useHttpClient } from "../../../../shared/http/HttpClientProvider";
import { QueryResult } from '../../../../shared/types/query';
import { IPublicApiResponse, publicApiParser } from '../types/publicApi';
// import {
//   ServerConfiguration,
// } from '../../../core/configuration/types/server-configuration';

export const KEY_PUBLIC_API_TOKEN_LIST = 'configuration/public_api_token_list';

export function useGetTokens(): QueryResult<IPublicApiResponse[], AxiosResponse> {
  const http = useHttpClient();

  return useQuery({
    queryKey: [KEY_PUBLIC_API_TOKEN_LIST],
    queryFn: async () => {
      return http.request({
        method: 'get',
        url: 'ApiClient',
      }).then(result => result.data.map(publicApiParser.fromJson))
    },
  })
}